import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["results"]

  find(event) {
    event.preventDefault()
    if (!navigator.geolocation) {
      this.resultsTarget.innerHTML = '<div class="alert alert-warning">Geolocation is not supported by your browser.</div>'
      return
    }
    this.resultsTarget.innerHTML = '<div class="alert alert-info">Locating…</div>'
    navigator.geolocation.getCurrentPosition(
      position => {
        fetch(`/mosques/nearby?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}`)
          .then(response => response.text())
          .then(html => {
            this.resultsTarget.innerHTML = html
          })
          .catch(() => {
            this.resultsTarget.innerHTML = '<div class="alert alert-danger">Could not fetch nearby mosques.</div>'
          })
      },
      () => {
        this.resultsTarget.innerHTML = '<div class="alert alert-warning">Unable to retrieve your location.</div>'
      }
    )
  }
}
